module.exports = "/_next/static/images/footer-logo-0b08d8bb33e3a08e53ef9951e307ef83.svg";